module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/shop_chapelsuns_01-04d83a1cb2ad24abab4ab4e008e9e26f.png";